//Auteur: Xavier Tribolet
//ServiceWorker environment
export const environment = {
  production: true,
  env : 'test',
  apiUrl: 'https://test.dimension-sport.be/mobile/api/',
  version: '1.18.14 - Test',
};
